module.exports = __webpack_public_path__ + "img/anniversary.6e262b81.svg";